const prefix = '@PromptX';
export const cookies = {
  promptListFilters: `${prefix}.prompt-list-filters`,
  adminSettings: `${prefix}.admin-settings`,
};
